import * as React from 'react';

import { Group } from './components/Group';
import { Filter } from './components/Filter';

import * as styles from './Filters.css';
import { TFilter } from '../../types/filters';

interface IFiltersProps {
  dealType?: React.ReactNode;
  offerType?: React.ReactNode;
  roomType?: React.ReactNode;
  posessor?: React.ReactNode;
  bedrooms?: React.ReactNode;
  price?: React.ReactNode;
  area?: React.ReactNode;
  landArea?: React.ReactNode;
  advancedFilters?: React.ReactNode;
  geo?: React.ReactNode;
  savedSearch?: React.ReactNode;
  applyButton?: React.ReactNode;
  tags?: React.ReactNode;
}

type TMainFilter = Exclude<TFilter, 'geo'>;

const MAIN_FILTERS_GROUP: TMainFilter[] = [
  'dealType',
  'offerType',
  'roomType',
  'posessor',
  'bedrooms',
  'price',
  'area',
  'landArea',
  'advancedFilters',
];

export const Filters: React.FC<IFiltersProps> = ({ geo, savedSearch, applyButton, tags, ...restFilters }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['layout']}>
        <div className={styles['filters-layout']}>
          <Group>
            {MAIN_FILTERS_GROUP.filter(filterKey => Boolean(restFilters[filterKey])).map(filterKey => (
              <Filter key={`filter_${filterKey}`} id={`mainFilter_${filterKey}`}>
                {restFilters[filterKey]}
              </Filter>
            ))}
          </Group>
          <Group className={styles['secondary-group']}>
            {geo && <Filter className={styles['geo']}>{geo}</Filter>}
            {applyButton && <div className={styles['button']}>{applyButton}</div>}
            {savedSearch && <div className={styles['button']}>{savedSearch}</div>}
          </Group>
        </div>
        {tags && <div className={styles['tags-layout']}>{tags}</div>}
      </div>
    </div>
  );
};
